var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 109,
    viewBox: "0 0 146 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5418_13978)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5418_13978)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_5418_13978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.791 3.07812H5.66266C3.13285 3.07812 1.08203 5.12894 1.08203 7.65875V101.562C1.08203 104.091 3.13285 106.142 5.66266 106.142H140.791C143.321 106.142 145.372 104.091 145.372 101.562V7.65875C145.372 5.12894 143.321 3.07812 140.791 3.07812Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3974 16.8183C16.3461 16.8183 17.1151 16.0492 17.1151 15.1005C17.1151 14.1519 16.3461 13.3828 15.3974 13.3828C14.4487 13.3828 13.6797 14.1519 13.6797 15.1005C13.6797 16.0492 14.4487 16.8183 15.3974 16.8183Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1201 16.8183C22.0687 16.8183 22.8378 16.0492 22.8378 15.1005C22.8378 14.1519 22.0687 13.3828 21.1201 13.3828C20.1714 13.3828 19.4023 14.1519 19.4023 15.1005C19.4023 16.0492 20.1714 16.8183 21.1201 16.8183Z",
    fill: "#FCD34D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8466 16.8183C27.7953 16.8183 28.5644 16.0492 28.5644 15.1005C28.5644 14.1519 27.7953 13.3828 26.8466 13.3828C25.898 13.3828 25.1289 14.1519 25.1289 15.1005C25.1289 16.0492 25.898 16.8183 26.8466 16.8183Z",
    fill: "#83E83F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.615 24.8359H18.2603C15.7305 24.8359 13.6797 26.8868 13.6797 29.4166V46.5939C13.6797 49.1237 15.7305 51.1745 18.2603 51.1745H123.615C126.145 51.1745 128.195 49.1237 128.195 46.5939V29.4166C128.195 26.8868 126.145 24.8359 123.615 24.8359Z",
    fill: "#4B22A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4779 55.7656H16.5426C14.9614 55.7656 13.6797 57.0474 13.6797 58.6285V58.6285C13.6797 60.2097 14.9614 61.4914 16.5426 61.4914H55.4779C57.059 61.4914 58.3408 60.2097 58.3408 58.6285C58.3408 57.0474 57.059 55.7656 55.4779 55.7656Z",
    fill: "#4B22A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.172 84.1406C133.172 78.0655 128.247 73.1406 122.172 73.1406C116.097 73.1406 111.172 78.0655 111.172 84.1406C111.172 90.2158 116.097 95.1406 122.172 95.1406C128.247 95.1406 133.172 90.2158 133.172 84.1406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.997 85.0052C121.532 85.0052 121.137 84.8439 120.815 84.5212C120.492 84.1986 120.331 83.8043 120.331 83.3386V79.3385C120.331 78.8728 120.492 78.4785 120.815 78.1559C121.137 77.8332 121.532 77.6719 121.997 77.6719C122.463 77.6719 122.857 77.8332 123.18 78.1559C123.503 78.4785 123.664 78.8728 123.664 79.3385V83.3386C123.664 83.8043 123.503 84.1986 123.18 84.5212C122.857 84.8439 122.463 85.0052 121.997 85.0052ZM121.497 89.8386V87.641C120.397 87.5154 119.484 87.0436 118.756 86.2257C118.028 85.4077 117.664 84.4453 117.664 83.3386H118.664C118.664 84.2608 118.989 85.0469 119.639 85.6969C120.289 86.3469 121.075 86.6719 121.997 86.6719C122.92 86.6719 123.706 86.3469 124.356 85.6969C125.006 85.0469 125.331 84.2608 125.331 83.3386H126.331C126.331 84.4453 125.967 85.4077 125.239 86.2257C124.511 87.0436 123.597 87.5154 122.497 87.641V89.8386H121.497Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5418_13978"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144.837,
    height: 107.558,
    fill: "white",
    transform: "translate(0.628906 0.90625)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5418_13978"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 145.651,
    height: 107.804,
    fill: "white",
    transform: "translate(0.628906 0.90625)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_5418_13978"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 145.651,
    height: 103.453,
    fill: "white",
    transform: "translate(0.628906 3.07812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomRight);
export default __webpack_public_path__ + "static/media/BottomRight.95d8eac243f33bc7b7ba53cdf0131680.svg";
export { ForwardRef as ReactComponent };